export default __webpack_public_path__ + "static/media/yamBlue.2ae07050.png";